import styled from '@emotion/styled';
import { theme } from '~/theme';

export const StyledListSelector = styled.div(() => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    width: '100%',
    listStyle: 'none',
    padding: theme.space[3],
    border: `1px solid ${theme.colors.brownLight}`,
    borderRadius: theme.sizes.cornerRadius,
    marginBottom: theme.space[3],
    cursor: 'pointer',
}));

export const StyledDroppointStore = styled.div(() => ({
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    paddingRight: theme.space[2],
}));

export const StyledDroppointStoreTitle = styled.div(() => ({
    fontSize: theme.fontSizes.xs,
    fontWeight: theme.fontWeights.medium,
    marginTop: theme.space[2],
}));

export const StyledDropPointStoreAdress = styled.div(() => ({
    display: 'flex',
    flexDirection: 'column',
    fontSize: theme.fontSizes.xs,
    fontWeight: theme.fontWeights.regular,
    lineHeight: theme.fontSizes.lg,
}));

export const StyledUlListSelector = styled.ul(() => ({
    width: '100%',
    listStyle: 'none',
    overflowY: 'auto',
    padding: 0,
}));
